(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9616],{

/***/ 43710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCrossIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21.633 19.222l-7.225-7.224 7.225-7.225a1.703 1.703 0 10-2.408-2.408L12 9.59 4.775 2.365a1.703 1.703 0 10-2.408 2.408l7.225 7.225-7.225 7.224a1.703 1.703 0 002.408 2.409L12 14.406l7.225 7.225a1.703 1.703 0 102.408-2.409z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.049 2.047a2.153 2.153 0 013.045 0L12 8.953l6.906-6.906a2.153 2.153 0 113.045 3.044l-6.906 6.907 6.906 6.906a2.153 2.153 0 01-3.045 3.045L12 15.042 5.094 21.95a2.153 2.153 0 11-3.045-3.045l6.906-6.906L2.05 5.09a2.153 2.153 0 010-3.044zm1.522.27a1.253 1.253 0 00-.886 2.138l7.543 7.543-7.543 7.543a1.253 1.253 0 001.772 1.771L12 13.77l7.543 7.542a1.253 1.253 0 101.772-1.771l-7.543-7.543 7.543-7.543a1.253 1.253 0 10-1.772-1.772L12 10.226 4.457 2.683a1.253 1.253 0 00-.886-.367z",
    fill: "#C8C8C8"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCrossIcon);

/***/ }),

/***/ 80851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLoadOutlined(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.332 14.483a1.333 1.333 0 001.333 0l4.665-2.666a1.333 1.333 0 00.667-1.153V5.332a1.334 1.334 0 00-.667-1.153L8.665 1.513a1.333 1.333 0 00-1.333 0L2.666 4.179A1.333 1.333 0 002 5.332v5.332a1.333 1.333 0 00.666 1.153l4.666 2.666zM7.998 14.663V7.998",
    stroke: "#2355FC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.193 4.666l5.805 3.332 5.805-3.332M4.999 2.846l5.998 3.432",
    stroke: "#2355FC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLoadOutlined);

/***/ }),

/***/ 38188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLocationArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.875 6.286a.853.853 0 00.611.812l4.987.43.43 4.986a.853.853 0 00.812.611h.016a.853.853 0 00.815-.577l3.53-9.517a.865.865 0 00-1.096-1.11l-.01.003-9.517 3.53a.854.854 0 00-.578.832z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLocationArrow);

/***/ }),

/***/ 97871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ DotLoader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../core-ui/dist/components/DotLoader/DotLoader.styles.js


const StyledDotLoader = styled_components_browser_esm/* default.div */.ZP.div `
    width: 15px;
    aspect-ratio: 1;
    border-radius: 50%;
    animation: loadingAnimation 1s infinite linear alternate;

    @keyframes loadingAnimation {
        0% {
            box-shadow: 20px 0 #000, -20px 0 #0002;
            background: #000;
        }
        33% {
            box-shadow: 20px 0 #000, -20px 0 #0002;
            background: #0002;
        }
        66% {
            box-shadow: 20px 0 #0002, -20px 0 #000;
            background: #0002;
        }
        100% {
            box-shadow: 20px 0 #0002, -20px 0 #000;
            background: #000;
        }
    }
`;


//# sourceMappingURL=DotLoader.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/DotLoader/DotLoader.js




const DotLoader = (0,react.forwardRef)((props, ref) => {
    return (0,jsx_runtime.jsx)(StyledDotLoader, Object.assign({}, props));
});


//# sourceMappingURL=DotLoader.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/DotLoader/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 28679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Shimmer; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
;// CONCATENATED MODULE: ../core-ui/dist/components/Shimmer/Shimmer.styles.js



const StyledShimmer = styled_components_browser_esm/* default.div */.ZP.div `
    width: 100%;
    height: ${({ height }) => { var _a; return (_a = (0,common/* getSizeInPx */.tf)(height)) !== null && _a !== void 0 ? _a : "auto"; }};
    min-height: ${({ minHeight }) => { var _a; return (_a = (0,common/* getSizeInPx */.tf)(minHeight)) !== null && _a !== void 0 ? _a : "120px"; }};
    border-radius: ${({ borderRadius }) => { var _a; return (_a = (0,common/* getSizeInPx */.tf)(borderRadius)) !== null && _a !== void 0 ? _a : "16px"; }};
    background: linear-gradient(90deg, #eef2ff 25%, #e0e7ff 50%, #eef2ff 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;

    @keyframes shimmer {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;


//# sourceMappingURL=Shimmer.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Shimmer/Shimmer.js




const Shimmer = (0,react.forwardRef)((props, ref) => {
    return (0,jsx_runtime.jsx)(StyledShimmer, Object.assign({ ref: ref }, props));
});


//# sourceMappingURL=Shimmer.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Shimmer/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 10169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89586);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89877);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91172);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43524);







var Swipper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props) {
    var list = props.list, className = props.className, _cssMode = props.cssMode, cssMode = _cssMode === void 0 ? true : _cssMode, _loop = props.loop, loop = _loop === void 0 ? false : _loop, autoplay = props.autoplay, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 1 : _slidesPerView, _spaceBetween = props.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 0 : _spaceBetween, breakpoints = props.breakpoints, _navigation = props.navigation, navigation = _navigation === void 0 ? true : _navigation, _pagination = props.pagination, pagination = _pagination === void 0 ? true : _pagination, _mousewheel = props.mousewheel, mousewheel = _mousewheel === void 0 ? true : _mousewheel, _keyboard = props.keyboard, keyboard = _keyboard === void 0 ? true : _keyboard, paginationRef = props.paginationRef, onSwiper = props.onSwiper;
    var modules = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var enabledModules = [];
        if (navigation) enabledModules.push(swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Navigation */ .W_);
        if (pagination) enabledModules.push(swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl);
        if (mousewheel) enabledModules.push(swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Mousewheel */ .Gk);
        if (keyboard) enabledModules.push(swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Keyboard */ .N1);
        if (autoplay) enabledModules.push(swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Autoplay */ .pt);
        return enabledModules;
    }, [
        autoplay,
        keyboard,
        mousewheel,
        navigation,
        pagination
    ]);
    var _key;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
        className: className,
        cssMode: cssMode,
        loop: loop,
        autoplay: autoplay === true ? {
            delay: 5000,
            pauseOnMouseEnter: true
        } : autoplay || undefined,
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        breakpoints: breakpoints,
        navigation: navigation,
        pagination: pagination === true ? {
            clickable: true
        } : pagination || undefined,
        mousewheel: mousewheel,
        keyboard: keyboard,
        modules: modules,
        onBeforeInit: function(swiper) {
            if ((paginationRef === null || paginationRef === void 0 ? void 0 : paginationRef.current) && swiper.params.pagination) {
                var pag = swiper.params.pagination;
                if (typeof pag !== "boolean") {
                    pag.el = paginationRef.current;
                }
            }
        },
        onSwiper: function(swiper) {
            onSwiper === null || onSwiper === void 0 ? void 0 : onSwiper(swiper);
        },
        children: list === null || list === void 0 ? void 0 : list.map(function(obj, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                children: obj.node
            }, (_key = obj.key) !== null && _key !== void 0 ? _key : index);
        })
    });
});
Swipper.displayName = "Swipper";
/* harmony default export */ __webpack_exports__["Z"] = (Swipper);


/***/ }),

/***/ 78582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ trackWebV2LocationField; },
/* harmony export */   "GR": function() { return /* binding */ trackLoadQuoteFormChange; },
/* harmony export */   "LF": function() { return /* binding */ trackLoadQuoteLocationInput; },
/* harmony export */   "gd": function() { return /* binding */ trackWebV2LorryTypeSelected; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14345);
/* harmony import */ var _load_quote__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20380);



function getLocationLabel(location) {
    var trimmed = location === null || location === void 0 ? void 0 : location.trim();
    return trimmed || undefined;
}
function trackWebV2LocationField(trackFieldOnce, params) {
    var location = getLocationLabel(params.location);
    if (!location) {
        return;
    }
    var eventName = params.field === "pickup" ? _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_0__/* .GA4EventNames.WEB_V2.pick_up_entered */ .wQ.WEB_V2.pick_up_entered : _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_0__/* .GA4EventNames.WEB_V2.drop_entered */ .wQ.WEB_V2.drop_entered;
    trackFieldOnce(params.field, eventName, {
        source_screen: params.sourceScreen,
        section: "location",
        location: location
    });
}
function trackWebV2LorryTypeSelected(trackFieldOnce, params) {
    var _dedupeSuffix, _lorryTypeLabel;
    trackFieldOnce("lorry-".concat((_dedupeSuffix = params.dedupeSuffix) !== null && _dedupeSuffix !== void 0 ? _dedupeSuffix : params.lorryTypeId), _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_0__/* .GA4EventNames.WEB_V2.lorry_type_selected */ .wQ.WEB_V2.lorry_type_selected, {
        source_screen: params.sourceScreen,
        section: "lorry type",
        lorry_type: (_lorryTypeLabel = params.lorryTypeLabel) !== null && _lorryTypeLabel !== void 0 ? _lorryTypeLabel : String(params.lorryTypeId)
    });
}
function trackLoadQuoteFormChange(trackFieldOnce, patch, context) {
    var ref, ref1;
    var sourceScreen = context.sourceScreen, isRemoteConfigLoaded = context.isRemoteConfigLoaded, previousValues = context.previousValues;
    if (patch.source && patch.source.place_id !== ((ref = previousValues.source) === null || ref === void 0 ? void 0 : ref.place_id)) {
        var _description, ref2;
        trackWebV2LocationField(trackFieldOnce, {
            field: "pickup",
            sourceScreen: sourceScreen,
            location: (ref2 = (_description = patch.source.description) !== null && _description !== void 0 ? _description : patch.source.locality) !== null && ref2 !== void 0 ? ref2 : patch.source.city
        });
    }
    if (patch.destination && patch.destination.place_id !== ((ref1 = previousValues.destination) === null || ref1 === void 0 ? void 0 : ref1.place_id)) {
        var _description1, ref3;
        trackWebV2LocationField(trackFieldOnce, {
            field: "drop",
            sourceScreen: sourceScreen,
            location: (ref3 = (_description1 = patch.destination.description) !== null && _description1 !== void 0 ? _description1 : patch.destination.locality) !== null && ref3 !== void 0 ? ref3 : patch.destination.city
        });
    }
    if (patch.tonnes != null && patch.tonnes !== previousValues.tonnes && (0,_load_quote__WEBPACK_IMPORTED_MODULE_2__/* .getLoadQuoteCapacityStatus */ .U1)(patch.tonnes, isRemoteConfigLoaded) === "valid") {
        trackFieldOnce("capacity", _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_0__/* .GA4EventNames.WEB_V2.capacity_entered */ .wQ.WEB_V2.capacity_entered, {
            source_screen: sourceScreen,
            section: "capacity",
            capacity: patch.tonnes
        });
    }
    if (patch.lorryType != null && patch.lorryType !== previousValues.lorryType) {
        var ref4;
        var ref5;
        var lorryLabel = (ref5 = (ref4 = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleInfoByLorryType */ .sB)(patch.lorryType, "load")) === null || ref4 === void 0 ? void 0 : ref4.label) !== null && ref5 !== void 0 ? ref5 : String(patch.lorryType);
        trackWebV2LorryTypeSelected(trackFieldOnce, {
            sourceScreen: sourceScreen,
            lorryTypeId: patch.lorryType,
            lorryTypeLabel: lorryLabel
        });
    }
}
function trackLoadQuoteLocationInput(trackFieldOnce, field, inputValue, sourceScreen) {
    trackWebV2LocationField(trackFieldOnce, {
        field: field,
        sourceScreen: sourceScreen,
        location: inputValue
    });
}


/***/ }),

/***/ 61782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useWebV2Tracker; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
;// CONCATENATED MODULE: ./components/homepage-v2/analytics/useWebV2PageOpened.ts

/** Fire a page-open WEB_V2 event once on mount. */ function useWebV2PageOpened(trackEvent, eventName, eventData) {
    var firedRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!trackEvent || !eventName || firedRef.current) {
            return;
        }
        firedRef.current = true;
        trackEvent(eventName, eventData);
    }, [
        eventData,
        eventName,
        trackEvent
    ]);
}

;// CONCATENATED MODULE: ./components/homepage-v2/analytics/useWebV2Tracker.ts



/**
 * Shared WEB_V2 tracking setup for top-level pages.
 *
 * Creates a stable `trackEvent`, injects `source_screen` as common `eventData`,
 * and optionally fires a page-opened event once on mount.
 */ function useWebV2Tracker(param) {
    var sourceScreen = param.sourceScreen, pageOpenedEventName = param.pageOpenedEventName;
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var trackEvent = (0,react.useCallback)(function(eventName, data) {
        var trackGa = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, trackMo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, trackFbCapi = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        sendGAandMoEngageEvent({
            name: eventName,
            data: data
        }, trackGa, trackMo, trackFbCapi);
    }, [
        sendGAandMoEngageEvent
    ]);
    var eventData = (0,react.useMemo)(function() {
        return {
            source_screen: sourceScreen
        };
    }, [
        sourceScreen
    ]);
    useWebV2PageOpened(trackEvent, pageOpenedEventName, eventData);
    return {
        trackEvent: trackEvent,
        eventData: eventData
    };
}


/***/ }),

/***/ 11452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_components_Shimmer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28679);
/* harmony import */ var _animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16440);
/* harmony import */ var _marketplace_load_card_v3_MarketplaceLoadCardV3__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37667);
/* harmony import */ var _marketplace_new_marketplace_posting_nudge_card_MarketplacePostingNudgeCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4564);
/* harmony import */ var _marketplace_new_marketplace_posting_nudge_card_marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98712);
/* harmony import */ var _AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49805);
/* harmony import */ var _AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var ANIMATION_STAGGER_MS = 75;
var AvailableLoadsGrid = function(param) {
    var loads = param.loads, cardIdPrefix = param.cardIdPrefix, onBidNow = param.onBidNow, _showPostingNudge = param.showPostingNudge, showPostingNudge = _showPostingNudge === void 0 ? false : _showPostingNudge, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _shimmerCount = param.shimmerCount, shimmerCount = _shimmerCount === void 0 ? 5 : _shimmerCount;
    if (isLoading && !loads.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7___default().grid),
            children: Array.from({
                length: shimmerCount
            }).map(function(_, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Shimmer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    minHeight: 285,
                    borderRadius: 14,
                    "aria-busy": true
                }, index);
            })
        });
    }
    var renderLoad = function(load, rank, animIndex) {
        var ref;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "scale-up",
            delay: animIndex * ANIMATION_STAGGER_MS,
            className: (_AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7___default().gridItem),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_marketplace_load_card_v3_MarketplaceLoadCardV3__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                id: "".concat(cardIdPrefix, "-load-").concat(rank),
                data: load,
                onBidNowClick: function() {
                    return onBidNow(load, rank);
                }
            })
        }, ((ref = load.load_detail) === null || ref === void 0 ? void 0 : ref.id) || "".concat(cardIdPrefix, "-load-").concat(rank));
    };
    var renderPostingNudge = function(type, animIndex) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "scale-up",
            delay: animIndex * ANIMATION_STAGGER_MS,
            className: (_AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7___default().nudgeSlot),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_marketplace_new_marketplace_posting_nudge_card_MarketplacePostingNudgeCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                type: type
            })
        }, "".concat(cardIdPrefix, "-post-").concat(type, "-nudge"));
    };
    if (!showPostingNudge) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7___default().grid),
            children: loads.map(function(load, index) {
                return renderLoad(load, index + 1, index);
            })
        });
    }
    var nudgeAfter = Math.min(_marketplace_new_marketplace_posting_nudge_card_marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_6__/* .MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX */ .Tm, loads.length);
    var loadsBeforeNudge = loads.slice(0, nudgeAfter);
    var loadsAfterNudge = loads.slice(nudgeAfter);
    var nudgeTypeCount = _marketplace_new_marketplace_posting_nudge_card_marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_6__/* .LOAD_MARKETPLACE_POSTING_NUDGE_TYPES.length */ .$d.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_AvailableLoadsGrid_module_scss__WEBPACK_IMPORTED_MODULE_7___default().grid),
        children: [
            loadsBeforeNudge.map(function(load, index) {
                return renderLoad(load, index + 1, index);
            }),
            _marketplace_new_marketplace_posting_nudge_card_marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_6__/* .LOAD_MARKETPLACE_POSTING_NUDGE_TYPES.map */ .$d.map(function(type, index) {
                return renderPostingNudge(type, nudgeAfter + index);
            }),
            loadsAfterNudge.map(function(load, index) {
                return renderLoad(load, nudgeAfter + index + 1, nudgeAfter + nudgeTypeCount + index);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvailableLoadsGrid);


/***/ }),

/***/ 36940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useCompactLoadBidAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4628);
/* harmony import */ var _compact_load_bidding_CompactLoadBiddingProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64200);





function useCompactLoadBidAction(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, preBidEventName = param.preBidEventName;
    var setShouldPreventLayoutSwitch = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).setShouldPreventLayoutSwitch;
    var openCompactBidding = (0,_compact_load_bidding_CompactLoadBiddingProvider__WEBPACK_IMPORTED_MODULE_2__/* .useCompactLoadBidding */ .dh)().openCompactBidding;
    var onClickLoadBid = function(loadBidData, rank) {
        if (preBidEventName) {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(preBidEventName, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventData), {
                rank: rank
            }));
        }
        // Keep marketing/dashboard layout stable while the bid sheet is open.
        // Without this, DefaultLayout swaps SideNav ↔ TopNav when the modal mounts.
        setShouldPreventLayoutSwitch === null || setShouldPreventLayoutSwitch === void 0 ? void 0 : setShouldPreventLayoutSwitch(true);
        openCompactBidding({
            loadData: loadBidData,
            trackRank: rank
        });
    };
    return {
        onClickLoadBid: onClickLoadBid
    };
}


/***/ }),

/***/ 37667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56560);
/* harmony import */ var _MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10182);
/* harmony import */ var _vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38920);
/* harmony import */ var _vahak_core_dist_standard_icons_load_outlined_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80851);
/* harmony import */ var _vahak_core_dist_icons_share_blue_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58352);
/* harmony import */ var _admin_IfCanAccess_IfCanAccess__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6632);
/* harmony import */ var _hooks_useHomepageV2Translation__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14394);
/* harmony import */ var _load_market_route__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51834);
/* harmony import */ var _getLoadDisplayBodyType__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33293);



// Styles

// Core Constants & Methods





// Icons


// Local Components




var MarketplaceLoadCardV3 = function(param) {
    var id = param.id, data = param.data, onBidNowClick = param.onBidNowClick, className = param.className, hideShareButton = param.hideShareButton;
    var ref;
    var t = (0,_hooks_useHomepageV2Translation__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .Il), setShowShareModalPopup = ref1.setShowShareModalPopup, companyId = ref1.companyId;
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_6__/* .useEventTrackerService */ .f)().sendGAandMoEngageEvent;
    var loadDetail = data.load_detail, companyDetail = data.company_detail;
    var cardId = id || "mkt-load-card-".concat((loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.id) || "preview");
    var lorryInfo = (0,_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_4__/* .getLorryDetailsByType */ .X9c)(loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.lorry_type_id);
    var capacityUnit = (lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.unit) === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_4__/* .LORRY_CAPACITY_UNIT_TYPES.TONNES */ .f5d.TONNES ? (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.quantity) === 1 ? t("mktCardV2:tonne") : t("mktCardV2:tonnes") : (lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.unitSingular) || t("mktCardV2:tonne");
    var sizeValue = loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.size;
    var sizeUnit = (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.size_text) || t("mktCardV2:ft");
    var bodyType = (0,_getLoadDisplayBodyType__WEBPACK_IMPORTED_MODULE_13__/* .getLoadDisplayBodyType */ .V)(loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.lorry_type_id, loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.body_type);
    var lorryTypeLabel = lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.label;
    var loadingTime = (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.loading_timestamp) ? (0,_vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)((0,_vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_7__/* .toValidDate */ .w0)(loadDetail.loading_timestamp * 1000), "DD MMM YYYY, h:mm a") : "--";
    // const isTopUser = !!companyDetail?.is_priority_user;
    // const isTopRoute = !!loadDetail?.meta_data?.is_load_in_top_routes;
    var isBestPrice = !!(loadDetail === null || loadDetail === void 0 ? void 0 : (ref = loadDetail.meta_data) === null || ref === void 0 ? void 0 : ref.is_best_price);
    var subtitleParts = [];
    if (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.quantity) {
        subtitleParts.push("".concat(loadDetail.quantity, " ").concat(capacityUnit));
    }
    if (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.total_tyres) {
        var tyreLabel = loadDetail.total_tyres > 1 ? t("mktCardV2:tyres") : t("mktCardV2:tyre");
        subtitleParts.push("".concat(loadDetail.total_tyres, " ").concat(tyreLabel));
    }
    if (sizeValue) {
        subtitleParts.push("".concat(sizeValue, " ").concat(sizeUnit));
    }
    var lorryTypeDisplay = bodyType ? "".concat(lorryTypeLabel, " (").concat(bodyType, ")") : lorryTypeLabel || "--";
    var subtitleText = subtitleParts.join(" • ");
    var paymentTypeLabel = (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.payment_type) === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_TYPE.Advance */ .V_z.Advance ? t("mktCardV2:paymentAdvance") : t("mktCardV2:paymentToPay");
    var advancePercentage = loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.advance_payment_percentage;
    var paymentMeta = (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.payment_type) === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_4__/* .PAYMENT_TYPE.Advance */ .V_z.Advance ? advancePercentage ? "".concat(advancePercentage, "% ").concat(paymentTypeLabel) : paymentTypeLabel : paymentTypeLabel;
    var showPriceSubtext = !!paymentMeta;
    var toggleShareModal = function() {
        var ref, ref1;
        setShowShareModalPopup === null || setShowShareModalPopup === void 0 ? void 0 : setShowShareModalPopup({
            isVisible: true,
            mktType: "load",
            data: {
                id: loadDetail.id,
                source: loadDetail.source_city_name,
                destination: (ref = loadDetail.destination) === null || ref === void 0 ? void 0 : ref.split("(")[0],
                quantity: loadDetail.quantity,
                lorry_type_id: (ref1 = (0,_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_4__/* .getLorryDetailsByType */ .X9c)(loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.lorry_type_id)) === null || ref1 === void 0 ? void 0 : ref1.id,
                lorry_type_text: loadDetail.lorry_type,
                transporter_name: loadDetail.destination_city_name,
                oppositeCompanyId: companyId,
                loadCardData: data
            }
        });
    };
    var handleStopsClick = function() {
        sendGAandMoEngageEvent({
            name: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_5__/* .GA4EventNames.WEB_V2.stop_clicked */ .wQ.WEB_V2.stop_clicked,
            data: {
                source_screen: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_5__/* .WEB_V2_SOURCE_SCREENS.BID_FORM */ .ZM.BID_FORM
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().card), className),
        id: cardId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().iconWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_load_outlined_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().headerContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().title),
                                id: "".concat(cardId, "--quantity"),
                                title: subtitleText,
                                children: subtitleText || t("mktCardV2:goods")
                            }),
                            (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.material_type) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().subtitle),
                                id: "".concat(cardId, "--material"),
                                title: loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.material_type,
                                children: loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.material_type
                            }) : null
                        ]
                    }),
                    !hideShareButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().shareBtn),
                        onClick: toggleShareModal,
                        id: "".concat(cardId, "--share"),
                        "aria-label": t("common:share_load"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_share_blue_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "aria-hidden": true
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_load_market_route__WEBPACK_IMPORTED_MODULE_12__/* .LoadMarketRouteSection */ .Ey, {
                loadDetail: loadDetail,
                variant: "marketCard",
                idPrefix: id,
                onStopsClick: handleStopsClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailsSection),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailBlock),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailLabel),
                                children: t("mktCardV2:lorryType")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailValue),
                                id: "".concat(cardId, "--lorryType"),
                                children: lorryTypeDisplay
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailBlock),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailLabel),
                                children: t("mktCardV2:loadingTime")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().detailValue),
                                id: "".concat(cardId, "--loadingTime"),
                                children: loadingTime
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().footer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().priceSection),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().priceLabel),
                                children: t("mktCardV2:price")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().priceRow),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().priceValue),
                                        id: "".concat(cardId, "--expectedPrice"),
                                        children: (loadDetail === null || loadDetail === void 0 ? void 0 : loadDetail.expected_amount) ? (0,_vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_7__/* .getPriceString */ .Bn)(loadDetail.expected_amount) : "--"
                                    }),
                                    isBestPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().bestPriceBadge),
                                        children: t("mktCardV2:bestPrice")
                                    })
                                ]
                            }),
                            showPriceSubtext ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().priceSubtext),
                                id: "".concat(cardId, "--priceMeta"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().priceSubtextAdvance),
                                    children: [
                                        "(",
                                        paymentMeta,
                                        ")"
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    !!onBidNowClick && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_admin_IfCanAccess_IfCanAccess__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        action: "",
                        allowCustomer: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: (_MarketplaceLoadCardV3_module_scss__WEBPACK_IMPORTED_MODULE_14___default().bidNowBtn),
                            onClick: onBidNowClick,
                            id: "".concat(cardId, "--bidNow"),
                            children: t("mktCardV2:bidNow")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MarketplaceLoadCardV3);


/***/ }),

/***/ 38038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useGetLoadStops; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46492);


// services



var useGetLoadStops = function(param, options) {
    var loadId = param.loadId;
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().GET;
    var method = function() {
        var payload = {
            id: loadId
        };
        if (payload === null || payload === void 0 ? void 0 : payload.id) {
            var URL = "".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_3__/* ["default"].USER_LOAD_STOPS */ .Z.USER_LOAD_STOPS).concat((0,_vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__/* .generateQueryString */ .T9)(payload));
            return GET(URL);
        }
        return {};
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakQuery */ .uE)(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__/* .QueryNames.userLoads.getLoadStops */ ._.userLoads.getLoadStops, method, options);
};


/***/ }),

/***/ 49805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"AvailableLoadsGrid_grid__XFcEY","gridItem":"AvailableLoadsGrid_gridItem__cQaVb","nudgeSlot":"AvailableLoadsGrid_nudgeSlot__crVOo"};

/***/ }),

/***/ 76045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AvailableLoadsSectionV2_container__yE8MT","header":"AvailableLoadsSectionV2_header__I_yqw","eyebrow":"AvailableLoadsSectionV2_eyebrow__I2QWn","title":"AvailableLoadsSectionV2_title__39kGQ","titleLine":"AvailableLoadsSectionV2_titleLine__RuJeW","titleHighlight":"AvailableLoadsSectionV2_titleHighlight__6sltS","viewMoreWrap":"AvailableLoadsSectionV2_viewMoreWrap__M95Dd","viewMoreBtn":"AvailableLoadsSectionV2_viewMoreBtn__8B3rq","hpv2HeroSlideIn":"AvailableLoadsSectionV2_hpv2HeroSlideIn__Z9Cvq","hpv2HeroFadeIn":"AvailableLoadsSectionV2_hpv2HeroFadeIn__SBdjE","hpv2HeroFadeInOpacity":"AvailableLoadsSectionV2_hpv2HeroFadeInOpacity__uOXd5","hpv2FadeUp":"AvailableLoadsSectionV2_hpv2FadeUp__Ja6YT","hpv2FadeLeft":"AvailableLoadsSectionV2_hpv2FadeLeft__WCkzg","hpv2FadeRight":"AvailableLoadsSectionV2_hpv2FadeRight__5xns0","hpv2ScaleUp":"AvailableLoadsSectionV2_hpv2ScaleUp__eagSg","hpv2Blink":"AvailableLoadsSectionV2_hpv2Blink__9wOkX","hpv2FloatA":"AvailableLoadsSectionV2_hpv2FloatA__XUn9b","hpv2FloatB":"AvailableLoadsSectionV2_hpv2FloatB__U_LDj","hpv2DemoProgress":"AvailableLoadsSectionV2_hpv2DemoProgress__P_c0f","hpv2DemoSlideIn":"AvailableLoadsSectionV2_hpv2DemoSlideIn__wuU8k","hpv2DemoFadeIn":"AvailableLoadsSectionV2_hpv2DemoFadeIn__DaJTU","hpv2DemoScaleIn":"AvailableLoadsSectionV2_hpv2DemoScaleIn__GWBtK","hpv2DemoBounce":"AvailableLoadsSectionV2_hpv2DemoBounce__0cTEo","hpv2PulseDot":"AvailableLoadsSectionV2_hpv2PulseDot__cJo1Z","hpv2PriceShimmer":"AvailableLoadsSectionV2_hpv2PriceShimmer__oKrtd"};

/***/ }),

/***/ 56560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"MarketplaceLoadCardV3_card___CFOo","header":"MarketplaceLoadCardV3_header__2TT9z","iconWrapper":"MarketplaceLoadCardV3_iconWrapper___g4_T","headerContent":"MarketplaceLoadCardV3_headerContent__9O0xX","shareBtn":"MarketplaceLoadCardV3_shareBtn__0nc32","title":"MarketplaceLoadCardV3_title__7CHGY","subtitle":"MarketplaceLoadCardV3_subtitle__QwlaQ","badges":"MarketplaceLoadCardV3_badges__adUY1","badge":"MarketplaceLoadCardV3_badge__WCbXG","badgeIcon":"MarketplaceLoadCardV3_badgeIcon__gCefm","topUserBadge":"MarketplaceLoadCardV3_topUserBadge__x5wlD","topRouteBadge":"MarketplaceLoadCardV3_topRouteBadge__ft0J7","detailsSection":"MarketplaceLoadCardV3_detailsSection__TAa6Q","detailBlock":"MarketplaceLoadCardV3_detailBlock__zn6WJ","detailLabel":"MarketplaceLoadCardV3_detailLabel__jXxn8","detailValue":"MarketplaceLoadCardV3_detailValue__PYEHx","footer":"MarketplaceLoadCardV3_footer__y1d5i","priceSection":"MarketplaceLoadCardV3_priceSection__abkPo","priceLabel":"MarketplaceLoadCardV3_priceLabel__jca97","priceRow":"MarketplaceLoadCardV3_priceRow__L_z04","priceValue":"MarketplaceLoadCardV3_priceValue__6bYwt","bestPriceBadge":"MarketplaceLoadCardV3_bestPriceBadge__mlGi9","priceSubtext":"MarketplaceLoadCardV3_priceSubtext__8hcT1","priceSubtextAdvance":"MarketplaceLoadCardV3_priceSubtextAdvance__pStYQ","priceSubtextRate":"MarketplaceLoadCardV3_priceSubtextRate__gfUyJ","priceSubtextDot":"MarketplaceLoadCardV3_priceSubtextDot__BSlPa","bidNowBtn":"MarketplaceLoadCardV3_bidNowBtn__tNYI_","hpv2HeroSlideIn":"MarketplaceLoadCardV3_hpv2HeroSlideIn__n7ayE","hpv2HeroFadeIn":"MarketplaceLoadCardV3_hpv2HeroFadeIn__wH5YK","hpv2HeroFadeInOpacity":"MarketplaceLoadCardV3_hpv2HeroFadeInOpacity__IhmHK","hpv2FadeUp":"MarketplaceLoadCardV3_hpv2FadeUp__u9BeC","hpv2FadeLeft":"MarketplaceLoadCardV3_hpv2FadeLeft__Ux3ZN","hpv2FadeRight":"MarketplaceLoadCardV3_hpv2FadeRight__GoHbw","hpv2ScaleUp":"MarketplaceLoadCardV3_hpv2ScaleUp__sUkjJ","hpv2Blink":"MarketplaceLoadCardV3_hpv2Blink__hG5hu","hpv2FloatA":"MarketplaceLoadCardV3_hpv2FloatA__DN9bx","hpv2FloatB":"MarketplaceLoadCardV3_hpv2FloatB__2_Hxd","hpv2DemoProgress":"MarketplaceLoadCardV3_hpv2DemoProgress__D3fJd","hpv2DemoSlideIn":"MarketplaceLoadCardV3_hpv2DemoSlideIn__HEr1o","hpv2DemoFadeIn":"MarketplaceLoadCardV3_hpv2DemoFadeIn__55Vik","hpv2DemoScaleIn":"MarketplaceLoadCardV3_hpv2DemoScaleIn__1CtFB","hpv2DemoBounce":"MarketplaceLoadCardV3_hpv2DemoBounce__iyU_6","hpv2PulseDot":"MarketplaceLoadCardV3_hpv2PulseDot__5CYr3","hpv2PriceShimmer":"MarketplaceLoadCardV3_hpv2PriceShimmer__Ek_c2"};

/***/ }),

/***/ 89877:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 91172:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);